/**
 * @generated SignedSource<<ec2181da20ef7d3cbb45a07e107692ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExperienceSettingsDetailsFormFields_Fragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsStatusRadioGroupFragment">;
  readonly " $fragmentType": "ExperienceSettingsDetailsFormFields_Fragment";
};
export type ExperienceSettingsDetailsFormFields_Fragment$key = {
  readonly " $data"?: ExperienceSettingsDetailsFormFields_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsDetailsFormFields_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceSettingsDetailsFormFields_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExperienceSettingsStatusRadioGroupFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "2c6a4856bed476577bf9ea176c0cd1df";

export default node;
